import React from 'react';
import { useTranslation } from "react-i18next";
import './ParentARMBoxes.scss';
import ParentARMBox from './ParentARMBox';
import getLatestARMBox from '../../../util/getLatestARMBox';
import { useSelector } from 'react-redux';

// group of three ParentARMBoxes, with ARM description
export default function ParentARMBoxes(props) {
  const {armBoxes, studentName, armBoxRefs, i18n} = props;
  const selectedLocale = useSelector(state => state?.reports?.teacher?.selectedLocale || "EN-US")

  const { t } = useTranslation(["teacher_parent_report"], {i18n});

  const windows = ['BOY', 'MOY', 'EOY'];

  const latestARMBox = getLatestARMBox(armBoxes);
  const {armScore, metric, percentile, benchmarkGrade} = latestARMBox;

  const scoreString = armScore?.toString();
  const leftScore = scoreString?.split(".")[0];
  const rightScore = scoreString?.split(".")[1];
  const currentGradeString = t(`a ${leftScore} grade`);
  const nextGradeString = t(`a ${parseInt(leftScore)+1} grade`);
  const rightScoreTensDigit = rightScore?.[0] || "0";
  const rightScoreDescription = t(`${rightScoreTensDigit} month`);
  const tContext = {
    leftScore,
    rightScore,
    currentGradeString,
    nextGradeString,
    rightScoreDescription,
    studentName,
    interpolation: { escapeValue: false },
  };

  return (
    <>
      {metric === 'ARM' && <div className={`parent-ARM-descriptions-container ${latestARMBox.window}`}>
        <div className='parent-ARM-descriptions'>
          <div className='parent-ARM-description'>{t("left_score_description", tContext)}</div>
          <div className='parent-ARM-description'>{t("right_score_description", tContext)}</div>
        </div>
      </div>}
      <div className='parent-ARM-boxes'>
        {windows.map(window => 
          <ParentARMBox 
            i18n={i18n}
            armBoxRefs={armBoxRefs}
            key={window}
            armBox={armBoxes[window]}
            benchmarkGrade={benchmarkGrade}
            selectedLocale={selectedLocale}
            isLatestARMBox={window === latestARMBox.window}
          />
        )}
      </div>
    </>
  )
}
